import { WriteRequest } from "~/backendApis/foundation/WriteRequest"
import { ReceptionStatus } from "~/backendApis/viewModel/externalNotification"

interface Params {
  email: string
  mailMagazineReceptionStatus: ReceptionStatus
  phoneNumber: string
}

export class CreateContactInformationWriteRequest extends WriteRequest<void> {
  private readonly endpoint: string =
    "/external_notification/user/contact_information/create"
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public post(): Promise<void> {
    return this.apiClient.post(this.endpoint, this.params)
  }
}
